<!--main central images start-->
<section class="agency aboutus p-0" *ngIf="theme=='light'; else darktheme">
    <div class="container">
        <div class="body-images"><img src="../../../assets/images/agency/service/service-images/{{img}}.png" [alt]="img"
                loading="lazy"></div>
    </div>
</section>
<!--main central images end-->

<ng-template #darktheme>
    <section class="saas1 build-bg">
        <div class="build-right-slider">
            <owl-carousel-o [options]="sync2" class="sync2" #owlCar (changed)="changeSlide($event, owlCar1)"
                (dragging)="owlCar1.to($event.data.startPosition.toString())">
                <ng-container *ngFor="let slide of buildsync; index as i">
                    <ng-template carouselSlide [id]="i" [dotContent]="owlCar1.to(i)">
                        <img [src]="slide.img" alt="work-slider" class="img-fluid work-slide" loading="lazy">
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="build-box">
                        <h3 class="build-head text-white"><span class="font-primary-light">Let’s </span>Build
                            Something
                            Great. <span class="font-primary-light">Together</span></h3>
                    </div>
                    <owl-carousel-o [options]="sync1" class="overflow-hidden sync1" #owlCar1
                        (dragging)="owlCar.to($event.data.startPosition.toString())">
                        <ng-container *ngFor="let slide of navsync; index as i">
                            <ng-template carouselSlide [id]="i">
                                <div class="build-box">
                                    <p>{{slide.data}}</p>
                                </div>
                            </ng-template>
                        </ng-container>
                    </owl-carousel-o>
                    <div class="build-box">
                        <ul>
                            <li class="filter-element"><img src="assets/images/saas1/build-.png" alt="icon"
                                    loading="lazy" >You leave a request for
                                consultation, which components of your product / service require calculation
                            </li>
                            <li><img src="assets/images/saas1/build-.png" alt="icon" loading="lazy">We make a video
                                meeting at the
                                agreed time
                            </li>
                            <li ><img src="assets/images/saas1/build-.png" alt="icon" loading="lazy">We prepare our
                                proposal for working
                                with automation and the inclution of a calculator in the chain of your business process
                            </li>
                            <li><img src="assets/images/saas1/build-.png" alt="icon" loading="lazy">We agree on
                                terms, milestones,
                                expend results and budget
                            </li>
                            <li><img src="assets/images/saas1/build-.png" alt="icon" loading="lazy">We form a team
                                for your project
                            </li>
                            <li><img src="assets/images/saas1/build-.png" alt="icon" loading="lazy">We implement the
                                solution together
                                with the team
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</ng-template>